"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function User(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (react_1.default.createElement("svg", { className: "icon ".concat(className), height: "".concat(height), viewBox: '0 0 64 64', width: "".concat(width) },
        react_1.default.createElement("path", { d: 'M31.9719 31.1162C36.6414 31.1162 40.4269 27.2846 40.4269 22.5581C40.4269 17.8315 39.1841 14 31.9719 14C24.7598 14 23.5167 17.8315 23.5167 22.5581C23.5167 27.2846 27.3023 31.1162 31.9719 31.1162Z', fill: '#010101' }),
        react_1.default.createElement("path", { d: 'M16.0017 44.1842C16.0002 43.8963 15.9988 44.1031 16.0017 44.1842V44.1842Z', fill: 'black' }),
        react_1.default.createElement("path", { d: 'M47.9414 44.4102C47.946 44.3314 47.943 43.8635 47.9414 44.4102V44.4102Z', fill: 'black' }),
        react_1.default.createElement("path", { d: 'M47.9228 43.84C47.7662 35.6064 46.4759 33.2602 36.6013 31.7752C36.6013 31.7752 35.2113 33.2511 31.9716 33.2511C28.7318 33.2511 27.3416 31.7752 27.3416 31.7752C17.5748 33.2441 16.2059 35.5554 16.0259 43.5726C16.0112 44.2272 16.0043 44.2616 16.0017 44.1856C16.0023 44.328 16.003 44.5913 16.003 45.0507C16.003 45.0507 18.3539 49 31.9716 49C45.589 49 47.9402 45.0507 47.9402 45.0507C47.9402 44.7555 47.9403 44.5503 47.9407 44.4108C47.9381 44.4577 47.9328 44.3668 47.9228 43.84Z', fill: '#010101' })));
}
User.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
User.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = User;
